import React from 'react';
import { withHandlers } from 'recompose';
import { compose } from 'ramda';

import { Button } from 'app/components/Button/Button';
import StackedLayout from 'app/components/layout/StackedLayout';
import connect from 'app/libs/connect';
import { validateCoupon } from 'app/features/couponCampaign/actions';
import CouponProductCta from 'app/features/couponCampaign/landing/components/CouponProductCta';

const handleValidationClick =
  ({ validateCoupon }) =>
  () =>
    validateCoupon();

// eslint-disable-next-line react/prop-types
const TestLayout = ({ onValidateCoupon }) => (
  <StackedLayout hasMarginTop>
    <StackedLayout.ContentBlock>
      <CouponProductCta> Select coupon code </CouponProductCta>
      <Button type="three" onClick={onValidateCoupon}>
        Trigger call to incentive engine to validate coupon
      </Button>
    </StackedLayout.ContentBlock>
  </StackedLayout>
);

export default compose(
  connect(null, { validateCoupon }),
  withHandlers({ onValidateCoupon: handleValidationClick }),
)(TestLayout);
